/* eslint-disable @typescript-eslint/no-explicit-any */
import { AnyAction, Reducer } from 'redux';

export interface IModals {
  modal: Record<string, any> | null;
}

export const initialState: IModals = {
  modal: null,
};

export enum actions {
  MODALS_SET_MODAL = 'MODALS_SET_MODAL',
}

export const reducer: Reducer<IModals, AnyAction> = (state = initialState, action) => {
  switch (action.type) {
    case actions.MODALS_SET_MODAL:
      return { ...state, modal: { ...action.payload } };
    default:
      return state;
  }
};
